import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Link } from 'react-router-dom';

const ScoringExplained = () => {
  const [expandedSection, setExpandedSection] = useState(null);
  const [backToWording, setBackToWording] = useState('Home');
  const [backToLink, setBackToLink] = useState('/');

    // Get parameters from URL
  const searchParams = new URLSearchParams(window.location.search);
  const openRulesOn = searchParams.get('openRulesOn');

  // use effect
  useEffect(() => {
    if (openRulesOn === 'match' || openRulesOn === 'table' || openRulesOn === 'match_leagues' || openRulesOn === 'table_leagues') {
        if (openRulesOn === 'match') {
            setExpandedSection(0);
            setBackToWording('Match Predictor');
            setBackToLink('/match-predictor');
        } else if (openRulesOn === 'table') {
            setExpandedSection(1);
            setBackToWording('Table Predictor');
            setBackToLink('/table-predictor');
        } else if (openRulesOn === 'match_leagues') {
            setExpandedSection(0);
            setBackToWording('Match Predictor Leagues');
            setBackToLink('/leagues');
        } else if (openRulesOn === 'table_leagues') {
            setExpandedSection(1);
            setBackToWording('Table Predictor Leagues');
            setBackToLink('/leagues?selectedType=table');
        }
      }
  }, [openRulesOn]);

  const sections = [
    {
      title: 'Match Predictor Scoring',
      content: [
        { points: 7, description: 'Exact score prediction' },
        { points: 4, description: 'Correct result and one correct team score' },
        { points: 2, description: 'Correct result only' },
        { points: 1, description: 'One correct team score only' },
        { points: 0, description: 'Incorrect prediction' }
      ]
    },
    {
      title: 'Table Predictor Scoring',
      content: [
        { points: 20, description: 'Exact position prediction' },
        { points: 19, description: 'Off by 1 position' },
        { points: 18, description: 'Off by 2 positions' },
        { points: '...', description: 'Points decrease by 1 for each position off' },
        { points: 2, description: 'Off by 18 positions' },
        { points: 1, description: 'Off by 19 positions' }
      ]
    }
  ];

  const toggleSection = (index) => {
    setExpandedSection(expandedSection === index ? null : index);
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
      <div className="w-full max-w-2xl p-6 bg-white rounded-lg shadow-md">
        <Link to={backToLink} className="text-premier-purple hover:text-premier-pink">Back to {backToWording}</Link>
        <h2 className="text-3xl font-bold text-premier-purple mb-6">Scoring Explained</h2>
        {sections.map((section, index) => (
            <div key={index} className="mb-6">
            <button
                className="flex justify-between items-center w-full text-left text-xl font-semibold text-premier-purple hover:text-premier-purple-light transition-colors duration-200"
                onClick={() => toggleSection(index)}
            >
                {section.title}
                {expandedSection === index ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
            </button>
            <motion.div
                initial={false}
                animate={{ height: expandedSection === index ? 'auto' : 0, opacity: expandedSection === index ? 1 : 0 }}
                transition={{ duration: 0.3, ease: 'easeInOut' }}
                className="overflow-hidden"
            >
                <table className="w-full mt-4">
                <thead>
                    <tr>
                    <th className="text-left font-semibold text-premier-purple">Points</th>
                    <th className="text-left font-semibold text-premier-purple">Description</th>
                    </tr>
                </thead>
                <tbody>
                    {section.content.map((item, itemIndex) => (
                    <tr key={itemIndex} className="border-b border-gray-200">
                        <td className="py-2 text-premier-purple font-medium">{item.points}</td>
                        <td className="py-2 text-gray-700">{item.description}</td>
                    </tr>
                    ))}
                </tbody>
                </table>
            </motion.div>
            </div>
        ))}
        <p className="mt-6 text-sm text-gray-600 italic">
            Note: Scores are calculated based on the latest available data and may be subject to live updates.
        </p>
        </div>
    </div>
  );
};

export default ScoringExplained;